import axios from 'axios'

export default {
  getWopiAccess: function (mnemo, fileId, mode) {
   return axios.get(`/room/${mnemo}/file/${fileId}/wopi/${mode}`)
  },
}
